import { render, staticRenderFns } from "./OssList.vue?vue&type=template&id=496f524c&scoped=true&"
import script from "./OssList.vue?vue&type=script&lang=js&"
export * from "./OssList.vue?vue&type=script&lang=js&"
import style0 from "./OssList.vue?vue&type=style&index=0&id=496f524c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f524c",
  null
  
)

export default component.exports